import { render, staticRenderFns } from "./AppSupportImage.vue?vue&type=template&id=358b8e0e&"
import script from "./AppSupportImage.vue?vue&type=script&lang=ts&"
export * from "./AppSupportImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QImg} from 'quasar'
component.options.components = Object.assign({QImg}, component.options.components || {})
